// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"2440":"datadogProfiler","3581":"datadogRecorder","8819":"bc0902ee"}[chunkId] || chunkId) + "." + {"298":"a6784f9f3fddb76d","2440":"0395b828c3b787e9","3581":"9fa3495b63861fbb","8135":"bb26a2baf880f5dd","8819":"4a976c1bfbfd1c90","9086":"7f283c2e010f5490"}[chunkId] + ".js";
};